class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this.close();
      }
    });

    this.querySelectorAll('.cart-notification__close, .cart-notification-continue').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });
  }

  open() {
    if (!this.notification) return;

    this.notification.removeAttribute('hidden');
    this.notification.classList.add('animate', 'active');

    setTimeout(() => {
      this.notification.focus();

      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }

      this.initRecommendationsSlider();
    }, 50);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');

    setTimeout(() => {
      if (!this.notification.classList.contains('active')) {
        this.notification.setAttribute('hidden', 'hidden');
      }
    }, 300);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);

      if (!elementToReplace) return;
      if (!parsedState.sections) return;
      if (!parsedState.sections[section.id]) return;

      const newContent = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      if (newContent !== null) {
        elementToReplace.innerHTML = newContent;
      }
    });

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedHTML.querySelector(selector);

    if (!selectedElement) return null;

    return selectedElement.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initRecommendationsSlider() {
    const tryInitSlider = () => {
      if (!window.jQuery) return;
      if (!window.jQuery.fn) return;
      if (!window.jQuery.fn.slick) return;

      const $sliders = window.jQuery('.cart-product-recommendations-slider');

      if (!$sliders.length) return;

      $sliders.each(function () {
        const $slider = window.jQuery(this);

        if ($slider.hasClass('slick-initialized')) return;

        const itemCount = $slider.find('li.grid__item').length;

        if (itemCount <= 1) return;

        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1.2,
                arrows: false
              }
            }
          ]
        });
      });
    };

    tryInitSlider();

    let attempts = 0;

    const sliderInterval = setInterval(() => {
      attempts += 1;
      tryInitSlider();

      if (attempts >= 20) {
        clearInterval(sliderInterval);
      }
    }, 300);
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}